<template>
  <div class="drawer">
    <el-drawer
      size="600px"
      title="体重配置列表"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div class="page">
        <div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="petType.name" label="宠物类型">
            </el-table-column>
            <el-table-column label="体重配置">
              <template slot-scope="scope">
                <div v-for="item in scope.row.configList" :key="item.id">
                  <span>
                    {{ item.typeName }}
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model="item.min"
                      style="
                        width: 40px;
                        border: 1px solid #dcdfe6;
                        border-radius: 4px;
                      "
                    />kg~
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model="item.max"
                      style="
                        width: 40px;
                        border: 1px solid #dcdfe6;
                        border-radius: 4px;
                      "
                    />kg
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="edit(scope.row)"
                  >确认修改</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      tableData: [],
      editInfo: {
        petType: {},
        configList: [],
      },
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getTableData();
    });
  },
  methods: {
    // 编辑体重配置
    edit(a) {
      this.editInfo = a;
    //   console.log(a);
      let params = {
        id: a.id,
        configList: a.configList,
      };
    //   console.log(params);
      let loading=this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/UpdateWeightConfig",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getTableData();
          }
        });
    },

    // 获取体重列表
    getTableData() {
      let loading=this.$loading();
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/Resvere/GetWeightConfigList")
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("体重配置列表", res);
            this.tableData = res.data;
          }
        });
    },
    //关闭弹框
    handleClose() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  padding: 20px;
  font-size: 14px;
}
</style>